(() => {
  let raf = 0;

  function setText(node, value) {
    if (node && node.textContent.trim() !== value) node.textContent = value;
  }

  function patchProductPage() {
    const root = document.querySelector('[data-dpv2-product]');
    if (!root) return;

    root.querySelectorAll('[data-dpv2-stock-text]').forEach(node => {
      const current = node.textContent.trim();
      if (/^in stock/i.test(current) || /ready to ship/i.test(current)) setText(node, 'Available');
      if (/sold out or unavailable/i.test(current)) setText(node, 'Unavailable');
    });

    root.querySelectorAll('.deko-form-error').forEach(error => {
      const message = error.textContent || '';
      if (
        /Set Shipping to United States and try again/i.test(message) ||
        /This item is available, but it cannot be added for the current delivery region/i.test(message)
      ) {
        setText(
          error,
          "This selection couldn't be added. Please review availability, shipping destination, and selected option, then try again."
        );
      }
    });
  }

  function schedule() {
    if (raf) return;
    raf = requestAnimationFrame(() => {
      raf = 0;
      patchProductPage();
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule, { once: true });
  else schedule();

  new MutationObserver(schedule).observe(document.documentElement, {
    childList: true,
    subtree: true,
    characterData: true
  });
})();
